import { createContext } from 'react';

const documentoContext = createContext();

export default documentoContext;